import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { Contact3D } from "../../../game/contact3d/Contact3D";
import { getBrowserFirebaseDatabase } from "../../../core/framework/firebase/BrowserFirebase";
import { CloseableFirebaseWrapper } from "../../../core/framework/firebase/CloseableFirebaseWrapper";
import { SerializingFirebaseWrapper } from "../../../core/framework/firebase/SerializingFirebaseWrapper";
import { BrowserFirebaseWrapper } from "../../../core/framework/firebase/BrowserFirebaseWrapper";
import { deleteApp } from "firebase/app";
import { useStage } from "./UseStage";
import { ClientGame } from "../../../core/game/client/ClientGame";
import { withGameContextListenerProvider } from "../../../core/game/client/useGameContext";
import { DebugFirebaseWrapper } from "../../../core/framework/firebase/DebugFirebaseWrapper";
const ActionClientContext = createContext(null);
const GameInstanceContext = createContext(null);
let savedGamesByIndex = Object.create(null);
export const GameContextProvider = (props) => {
    const { children, gameIndex, isTestingMode, username, desiredGame, fallback } = props;
    const stage = useStage();
    const { gameContextListener, replicatedActionClient, game, clientGame, } = useMemo(() => {
        if (savedGamesByIndex[gameIndex] === undefined) {
            const context = { gameIndex };
            globalThis.Debug.pushDebugContext(context);
            const game = new Contact3D(stage);
            const clientGame = new ClientGame();
            const { database, app } = getBrowserFirebaseDatabase(stage);
            const firebase = new CloseableFirebaseWrapper(new DebugFirebaseWrapper(new SerializingFirebaseWrapper(new BrowserFirebaseWrapper(database)), context));
            const { gameContextListener, replicatedActionClient, } = clientGame.create({
                props: {
                    isTestingMode,
                    username,
                    desiredGame,
                    firebase,
                    deleteApp: () => deleteApp(app),
                    testingModeIndex: gameIndex,
                },
                config: game.clientConfig
            });
            game.replicatedActionClient = replicatedActionClient;
            savedGamesByIndex[gameIndex] = {
                game,
                clientGame,
                gameContextListener,
                replicatedActionClient,
            };
            globalThis.Debug.popDebugContext(context);
        }
        return savedGamesByIndex[gameIndex];
    }, []);
    return withGameContextListenerProvider(gameContextListener, _jsx(GameInstanceContext.Provider, { value: {
            gameContextListener, replicatedActionClient, game, clientGame
        }, children: _jsx(gameContextListener.GameContextProviders, { fallback: fallback, children: _jsx(ActionClientContext.Provider, { value: replicatedActionClient, children: children }) }) }));
};
export function useActionClient() {
    return useContext(ActionClientContext);
}
export function clearGame(gameIndex) {
    savedGamesByIndex[gameIndex].clientGame.stop();
    delete savedGamesByIndex[gameIndex];
}
export function useCreateContact3DAction() {
    const actionClient = useActionClient();
    return (...args) => actionClient.createReplicatedAction(...args);
}
export function useGameInstance() {
    return useContext(GameInstanceContext).game;
}
//# sourceMappingURL=GameContextProvider.js.map